export default "__VITE_ASSET__d62f9b0c__"